import React from 'react';
import { DefaultRecordType } from 'rc-table/lib/interface';

export const ReportArrivCell = (value: any, record: DefaultRecordType) => (
  <React.Fragment>
    {value} {record.arrivalSecurityGateName} {record.branchName}
  </React.Fragment>
);
